import { render, staticRenderFns } from "./ProgramActivityReminderList.vue?vue&type=template&id=34ad5c6c&scoped=true"
import script from "./ProgramActivityReminderList.vue?vue&type=script&lang=js"
export * from "./ProgramActivityReminderList.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityReminderList.vue?vue&type=style&index=0&id=34ad5c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad5c6c",
  null
  
)

export default component.exports